import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { IBaseModel } from '../models/base.model';
import { BaseService } from './base.service';
import { Observable, Subject } from 'rxjs';
import { IOsaExecucaoFolhaTesteConsolidadaModel, IOsaExecucaoFolhaTesteModel, IOsaExecucaoFolhaTesteQuestaoModel, IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel, IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel } from '../models/osa-execucao-folha-teste-model';

@Injectable({
  providedIn: 'root',
})
export class OsaExecucaoFolhaTesteService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  //#region FolhaTeste

    public obterFolhaTestePorExecucao(osaExecucaoId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/osaExecucaoid/${osaExecucaoId}`)
          .toPromise();
    }

    public obterFolhaTestePorExecucaoUnidadeGestoraAmostra(osaExecucaoId: number, unidadeGestoraId: number, amostraId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/osaExecucaoId/${osaExecucaoId}/unidadeGestoraId/${unidadeGestoraId}/amostraId/${amostraId}`)
          .toPromise();
    }

    public obterUltimaFolhaTestePorExecucaoUnidadeGestoraAmostra(osaExecucaoId: number, unidadeGestoraId: number, amostraId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/ultima-folha-teste/osaExecucaoId/${osaExecucaoId}/unidadeGestoraId/${unidadeGestoraId}/amostraId/${amostraId}`)
          .toPromise();
    }

    public async obterFolhaTestePorId(id: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient
        .get<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/id/${id}`)
        .toPromise();
    }

    public async inserirFolhaTeste(data: IOsaExecucaoFolhaTesteModel): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient
      .post<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste`, data)
      .toPromise();
    }

    public atualizarFolhaTeste(data: IOsaExecucaoFolhaTesteModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient.put<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste`, data)
    }

    public async cancelarFolhaTeste(data: IOsaExecucaoFolhaTesteModel): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient
        .put<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/cancelar-folha-teste`, data)
        .toPromise();
    }

    public async habilitarFolhaTeste(data: IOsaExecucaoFolhaTesteModel): Promise<IBaseModel<IOsaExecucaoFolhaTesteModel>> {
      return this.httpClient
        .put<IBaseModel<IOsaExecucaoFolhaTesteModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/habilitar-folha-teste`, data)
        .toPromise();
    }    

    public async excluirFolhaTeste(id: number): Promise<IBaseModel<void>> {
      return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/${id}/excluir-folha-teste`)
      .toPromise();
    }

  //#endregion


  //#region FolhaTesteQuestao

    public async obterFolhaTesteQuestaoPorFolhaTeste(osaExecucaoFolhaTesteId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/osaExecucaoFolhaTesteId/${osaExecucaoFolhaTesteId}`)
          .toPromise();
    }

    public obterFolhaTesteQuestaoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/id/${Id}`)
          .toPromise();
    }

    public inserirFolhaTesteQuestao(data: IOsaExecucaoFolhaTesteQuestaoModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>> {
      return this.httpClient.post<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao`, data);
    }

    public async atualizarFolhaTesteQuestao(data: IOsaExecucaoFolhaTesteQuestaoModel): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>> {
      return this.httpClient.put<IBaseModel<IOsaExecucaoFolhaTesteQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao`, data)
        .toPromise();
    }

    public excluirFolhaTesteQuestao(id: number): Observable<IBaseModel<void>> {
      return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/${id}/excluir-folha-teste-questao`)
    }

    public async obterFolhaTesteQuestaoConsolidadaPorExecucaoEQuestao(osaExecucaoId: number, questaoId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteConsolidadaModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteConsolidadaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/consolidada/osaExecucaoId/${osaExecucaoId}/questaoId/${questaoId}`)
          .toPromise();
    }

    public async obterFolhaTesteQuestaoConsolidadaPorExecucaoEDescricaoQI(osaExecucaoId: number, descricaoQI: string): Promise<IBaseModel<IOsaExecucaoFolhaTesteConsolidadaModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteConsolidadaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/consolidada/osaExecucaoId/${osaExecucaoId}/descricaoQI/${descricaoQI}`)
          .toPromise();
    }

    //#endregion


  //#region FolhaTesteQuestaoPapelTrabalho

    public obterFolhaTesteQuestaoPapelTrabalhoPorFolhaTesteQuestao(osaExecucaoFolhaTesteQuestaoId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/osaExecucaoFolhaTesteQuestaoId/${osaExecucaoFolhaTesteQuestaoId}`)
          .toPromise();
    }

    public obterFolhaTesteQuestaoPapelTrabalhoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/id/${Id}`)
          .toPromise();
    }

    public inserirFolhaTesteQuestaoPapelTrabalho(data: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>> {
      return this.httpClient.post<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho`, data);
    }

    public atualizarFolhaTesteQuestaoPapelTrabalho(data: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>> {
      return this.httpClient.put<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho`, data)
    }

    public excluirFolhaTesteQuestaoPapelTrabalho(id: number): Observable<IBaseModel<void>> {
      return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/${id}/excluir-folha-teste-questao-papel-trabalho`)
    }

  //#endregion  


  //#region FolhaTesteQuestaoPapelTrabalhoArquivo

    public obterFolhaTesteQuestaoPapelTrabalhoArquivoPorFolhaTesteQuestaoPapelTrabalho(osaExecucaoFolhaTesteQuestaoPapelTrabalhoId: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel[]>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/arquivo/osaExecucaoFolhaTesteQuestaoPapelTrabalhoId/${osaExecucaoFolhaTesteQuestaoPapelTrabalhoId}`)
          .toPromise();
    }

    public obterFolhaTesteQuestaoPapelTrabalhoArquivoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>> {
      return this.httpClient
          .get<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/arquivo/id/${Id}`)
          .toPromise();
    }

    public inserirFolhaTesteQuestaoPapelTrabalhoArquivo(data: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>> {
      return this.httpClient.post<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/arquivo`, data);
    }

    public atualizarFolhaTesteQuestaoPapelTrabalhoArquivo(data: IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel): Observable<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>> {
      return this.httpClient.put<IBaseModel<IOsaExecucaoFolhaTesteQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/folha-teste/questao/papel-trabalho/arquivo`, data)
    }

    public excluirFolhaTesteQuestaoPapelTrabalhoArquivo(id: number): Observable<IBaseModel<void>> {
      return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoFolhaTeste/${id}/excluir-folha-teste-questao-papel-trabalho-arquivo`)
    }

  //#endregion  

}
